/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menulunchpublished2Inputs */

const en_menulunchpublished2 = /** @type {(inputs: Menulunchpublished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch menu is live`)
};

const de_menulunchpublished2 = /** @type {(inputs: Menulunchpublished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü ist live`)
};

/**
* | output |
* | --- |
* | "Lunch menu is live" |
*
* @param {Menulunchpublished2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menulunchpublished2 = /** @type {((inputs?: Menulunchpublished2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menulunchpublished2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menulunchpublished2(inputs)
	return de_menulunchpublished2(inputs)
});
export { menulunchpublished2 as "menuLunchPublished" }